import { DefaultValues } from "react-hook-form";
import * as yup from "yup";
import { generateRandomHexColor } from "../../../../common/infrastructure/utilities/colorUtility";

export const breakTypeSchema = yup
  .object({
    id: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .optional(),
    name: yup.string().required("Името е задължително").defined(),
    durationInMinutes: yup
      .number()
      .required("Продължителността е задължителна")
      .min(5, "Минимум 5 минути")
      .max(480, "Максимум 8 часа")
      .defined(),
    color: yup.string().required("Цветът е задължителен").defined(),
    description: yup.string().optional(),
    isDeleted: yup.boolean().optional(),
  })
  .required();

export type IBreakTypeInputModel = yup.InferType<typeof breakTypeSchema>;

export const getBreakTypeDefaults =
  (): DefaultValues<IBreakTypeInputModel> => ({
    name: "",
    durationInMinutes: 30,
    color: generateRandomHexColor(),
    description: "",
  });
